import { SystemStyleObject } from '@chakra-ui/react';

// Scales an image on hover. Apply it to the image element itself, inside an overflow-hidden container.
export const imageZoomSx: SystemStyleObject = {
  transition: 'transform 0.45s ease',
  willChange: 'transform',
  _hover: {
    transform: 'scale(1.025)',
  },
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
    _hover: {
      transform: 'none',
    },
  },
};
